import React from "react";
import { Box } from "@chakra-ui/react";

export const MasonryItem = ({ children, mb = "5", breakAfterColumn = false, breakBeforeColumn = false }) => {
  return (
    // Outer wrapper: handles column breaks
    <Box
      w="full"
      sx={{
        ...(breakBeforeColumn
          ? {
              breakBefore: "column",
              columnBreakBefore: "always",
              WebkitColumnBreakBefore: "always",
            }
          : {}),
        ...(breakAfterColumn
          ? {
              breakAfter: "column",
              columnBreakAfter: "always",
              WebkitColumnBreakAfter: "always",
            }
          : {}),
      }}
    >
      {/* Inner wrapper: makes the item atomic (prevents splitting across columns) */}
      <Box
        w="full"
        display="inline-block"
        mb={mb}
        verticalAlign="top"
        sx={{
          breakInside: "avoid",
          breakInside: "avoid-column",
          pageBreakInside: "avoid",
          WebkitColumnBreakInside: "avoid",
        }}
      >
        {children}
      </Box>
    </Box>
  );
};

export const CardsMasonry = ({ children, columns = { base: 1, md: 2 }, gap = "5" }) => {
  const items = React.Children.toArray(children);

  return (
    <Box
      w="full"
      columnCount={columns}
      columnGap={gap}
      sx={{
        // Helps reduce “balancing” weirdness in some cases
        columnFill: "auto",
      }}
    >
      {items.map((child, idx) => {
        if (child === null || child === undefined || typeof child === "boolean") return null;
        if (typeof child === "string" && child.trim() === "") return null;
        return (
        // default wrapper if not already a MasonryItem
        React.isValidElement(child) && child.type === MasonryItem ? (
          React.cloneElement(child, { key: idx })
        ) : (
          <MasonryItem key={idx} mb={gap}>
            {child}
          </MasonryItem>
        )
        );
      })}
    </Box>
  );
};

export default CardsMasonry;
